import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

// Optional: set global Chart.js defaults to match our dark theme
import { Chart as ChartJS } from "chart.js";

/** Read a CSS var with a fallback. */
function cssVar(name: string, fallback: string) {
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

// Apply theme-driven defaults once the document styles are available
(() => {
  const text = cssVar("--text", "#e7edf3");
  const axis = cssVar("--chart-axis", "#a8bdcf");
  const grid = cssVar("--chart-grid", "#243141");
  const border = cssVar("--border", "#1f2a36");
  const tooltipBg = cssVar("--tooltip-bg", "#0f141b");

  ChartJS.defaults.color = axis;
  ChartJS.defaults.font.family =
    'system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
  ChartJS.defaults.borderColor = grid;

  if (ChartJS.defaults.plugins?.legend?.labels) {
    ChartJS.defaults.plugins.legend.labels.color = text;
  }
  if (ChartJS.defaults.plugins?.tooltip) {
    ChartJS.defaults.plugins.tooltip.backgroundColor = tooltipBg;
    ChartJS.defaults.plugins.tooltip.borderColor = border;
    ChartJS.defaults.plugins.tooltip.borderWidth = 1;
    ChartJS.defaults.plugins.tooltip.titleColor = text;
    ChartJS.defaults.plugins.tooltip.bodyColor = text;
  }
})();

const container = document.getElementById("root")!;
createRoot(container).render(<App />);
